import Vue from 'vue';
import _ from 'lodash';

Vue.directive('auto-blur', {
  inserted: function (el) {
    el.onfocus = (ev: FocusEvent) => {
      if (!ev || !_.isFunction(_.get(ev, 'target.blur'))) {
        return;
      }
      let target = _.get(ev, 'target'); 
      let blur: (...arg: any) => any = _.get(ev, 'target.blur');
      blur.call(target); 
    }
  }
});